export const htmlToPlainText = (html?: string): string => {
  if (!html) return '';

  const withLineBreaks = html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li|h[1-6])>/gi, '\n');

  const { body } = new DOMParser().parseFromString(withLineBreaks, 'text/html');

  return (body.textContent ?? '').trim();
};
